import { Button } from "@/components/ui/button";
import { useAnalyticsCookieConsent } from "@/features/analytics/useAnalyticsCookieConsent";
import { useIdleMount } from "@/hooks/useIdleMount";
import { cn } from "@/lib/utils";

import { Link } from "wouter";

export function CookieConsentBanner() {
  const { showBanner, isUpdating, accept, decline } = useAnalyticsCookieConsent();
  const idleMounted = useIdleMount();

  if (!showBanner || !idleMounted) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-100 border-t border-border bg-white p-4 shadow-lg",
        "md:p-5"
      )}
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="container mx-auto flex max-w-4xl flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="text-sm text-muted-foreground space-y-1">
          <p id="cookie-consent-title" className="font-semibold text-foreground">
            Analytics cookies
          </p>
          <p id="cookie-consent-desc">
            We use first-party analytics (PostHog) to improve our website and platform. Your choice
            is shared across both, and we do not use analytics cookies until you accept. See our{" "}
            <Link
              href="/cookie-policy"
              className="font-medium text-brand-grass underline-offset-4 hover:underline"
            >
              Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2 md:justify-end">
          <Button type="button" variant="outline" disabled={isUpdating} onClick={decline}>
            Decline
          </Button>
          <Button type="button" disabled={isUpdating} onClick={accept}>
            Accept analytics cookies
          </Button>
        </div>
      </div>
    </div>
  );
}
